var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResourcesPageBannerW768Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 768 301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 300,
    fill: "url(#paint0_linear_10771_16460)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185.74 253.752C190.727 253.752 190.727 246 185.74 246C180.753 246 180.753 253.752 185.74 253.752Z",
    fill: "#A3EA2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6795 133.751C64.6663 133.751 64.6663 126 59.6795 126C54.6928 126 54.6928 133.751 59.6795 133.751Z",
    fill: "#A3EA2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.87973 195.405C4.38605 195.405 4.38605 191.53 1.87973 191.53C-0.626578 191.53 -0.626578 195.405 1.87973 195.405Z",
    fill: "#A3EA2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3543 300.1C76.8607 300.1 76.8607 296.224 74.3543 296.224C71.848 296.224 71.848 300.1 74.3543 300.1Z",
    fill: "#A3EA2A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M764.303 264.034C769.289 264.034 769.289 256.283 764.303 256.283C759.316 256.283 759.316 264.034 764.303 264.034Z",
    fill: "#A3EA2A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M661.88 202.876C664.386 202.876 664.386 199 661.88 199C659.373 199 659.373 202.876 661.88 202.876Z",
    fill: "#A3EA2A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M715.571 299.509C718.077 299.509 718.077 295.633 715.571 295.633C713.065 295.633 713.065 299.509 715.571 299.509Z",
    fill: "#A3EA2A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10771_16460",
    x1: 325.585,
    y1: -145.2,
    x2: 594.144,
    y2: 437.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#182337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#151C2B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesPageBannerW768Px);
export default __webpack_public_path__ + "static/media/resources-page-banner-w768px.9d4a79d5b5079fdb22f613dd3d0e9991.svg";
export { ForwardRef as ReactComponent };